import {NgModule} from '@angular/core';
import {AsConfigPage} from "./page/overview/config/config.page";
import {
    MsBusinessStaffMembersComponent
} from "./component/protected-components/ms/ms-business-staff-members/ms-business-staff-members.component";
import {MsBookComponent} from "./component/protected-components/ms/ms-book/ms-book.component";
import {AsOverviewPage} from "./page/as-overview-page/as-overview.page";
import {AsStatisticsComponent} from "./page/as-overview-page/components/statisticsComponent/as-statistics.component";
import {AsKpiComponent} from "./page/as-overview-page/components/kpiComponent/as-kpi.component";
import {AsCalendarComponent} from "./component/protected-components/as-calendar/as-calendar.component";
import {
    AsAppointmentEventComponent
} from "./component/protected-components/as-appointment-event/as-appointment-event.component";
import {
    AsCustomerAppointmentPage
} from "./component/protected-components/as-customer-appointment-page/as-customer-appointment.page";
import {
    AsCustomerAppointmentDetailPage
} from "./component/protected-components/as-customer-appointment-detail-page/as-customer-appointment-detail.page";
import {FloatLabelModule} from "primeng/floatlabel";
import {AsAgentMapComponent} from "./component/protected-components/as-agent-map/as-agent-map.component";
import {AsFreeSlotComponent} from "./component/protected-components/as-free-slot/as-free-slot.component";
import {
    AppointmentBookingObjectComponent
} from "./component/protected-components/object-component/appointment-booking-object-component/appointment-booking-object.component";
import {
    AppointmentBookingBaseComponent
} from "./component/protected-components/object-component/appointment-booking-object-component/view/appointment-booking-base.component";
import {
    AppointmentBookingSideComponent
} from "./component/protected-components/object-component/appointment-booking-object-component/view/side/appointment-booking-side.component";
import {
    AppointmentBookingFullComponent
} from "./component/protected-components/object-component/appointment-booking-object-component/view/full/appointment-booking-full.component";
import {
    AppointmentBookingComponent
} from "./component/protected-components/object-component/appointment-booking-object-component/shared/appointment-booking-component/appointment-booking.component";
import {
    AsCreatAppointmentComponent
} from "./component/protected-components/as-create-appointment/as-creat-appointment.component";
import {AsMsEventComponent} from "./component/protected-components/as-ms-event/as-ms-event.component";
import {
    AppointmentTypeBaseComponent
} from "./component/protected-components/object-component/appointment-type-component/view/appointment-type-base.component";
import {
    AppointmentTypeSideComponent
} from "./component/protected-components/object-component/appointment-type-component/view/side/appointment-type-side.component";
import {
    AppointmentTypeComponent
} from "./component/protected-components/object-component/appointment-type-component/appointment-type.component";
import {
    AppointmentTypeFullComponent
} from "./component/protected-components/object-component/appointment-type-component/view/full/appointment-type-full.component";
import {
    AppointmentTypeAgentPoolTableComponent
} from "./component/protected-components/object-component/appointment-type-component/shared/appointment-type-agent-pool-table-component/appointment-type-agent-pool-table.component";
import {
    AppointmentTypeBasicComponent
} from "./component/protected-components/object-component/appointment-type-component/shared/appointment-type-basic-component/appointment-type-basic.component";
import {
    AppointmentTypeScheduleTypeTableComponent
} from "./component/protected-components/object-component/appointment-type-component/shared/appointment-type-schedule-type-table-component/appointment-type-schedule-type-table.component";
import {
    AppointmentTypeAgentTableComponent
} from "./component/protected-components/object-component/appointment-type-component/shared/appointment-type-table-agent-table-component/appointment-type-agent-table.component";
import {TeamCalendarPage} from "./page/team-calendar-page/team-calendar.page";
import {DmModule} from "../../feature-core/dm/dm.module";
import {
    AsAppointmentInlineComponent
} from "./component/protected-components/as-appointment-inline-component/as-appointment-inline-component";
import {
    AsAppointmentCancelAppointmentComponent
} from "./component/protected-components/as-appointment-event/as-appointment-cancel-appointment/as-appointment-cancel-appointment.component";
import {
    AsAppointmentRescheduleAppointmentComponent
} from "./component/protected-components/as-appointment-event/as-appointment-reschedule-appointment/as-appointment-reschedule-appointment.component";
import {AS_ENTITY_PROVIDER} from "./as.entity-provider";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {PeriodDurationPipe} from "../../core/shared/pipes/mvs-period-duration.pipe";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {PMessagesComponent} from "../../core/shared/p-messages/p-messages.component";
import {AS_TEST_PROVIDERS} from "./test/as-test-definition";

@NgModule({
    declarations: [
        AsConfigPage,
        MsBusinessStaffMembersComponent,
        MsBookComponent,
        AsOverviewPage,
        AsStatisticsComponent,
        AsKpiComponent,
        AsCalendarComponent,
        AsAppointmentEventComponent,
        AsCustomerAppointmentPage,
        AsCustomerAppointmentDetailPage,
        AsAgentMapComponent,
        AsFreeSlotComponent,
        AppointmentBookingObjectComponent,
        AppointmentBookingBaseComponent,
        AppointmentBookingSideComponent,
        AppointmentBookingFullComponent,
        AppointmentBookingComponent,
        AsCreatAppointmentComponent,
        AsMsEventComponent,
        AppointmentTypeBaseComponent,
        AppointmentTypeSideComponent,
        AppointmentTypeComponent,
        AppointmentTypeFullComponent,
        AppointmentTypeAgentPoolTableComponent,
        AppointmentTypeBasicComponent,
        AppointmentTypeScheduleTypeTableComponent,
        AppointmentTypeAgentTableComponent,
        TeamCalendarPage,
        AsAppointmentInlineComponent,
        AsAppointmentCancelAppointmentComponent,
        AsAppointmentRescheduleAppointmentComponent,
    ],
    exports: [
        AsConfigPage,
        MsBookComponent,
        AsCalendarComponent,
        AsAppointmentEventComponent,
        AsCustomerAppointmentPage,
        AsCustomerAppointmentDetailPage,
        AsAgentMapComponent,
        AsFreeSlotComponent,
        AppointmentBookingObjectComponent,
        AppointmentBookingBaseComponent,
        AppointmentBookingSideComponent,
        AppointmentBookingFullComponent,
        AppointmentBookingComponent,
        AsCreatAppointmentComponent,
        AsMsEventComponent,
        TeamCalendarPage,
        AsAppointmentInlineComponent,
        AsAppointmentCancelAppointmentComponent,
        AsAppointmentRescheduleAppointmentComponent,
    ],
    imports: [
        CoreModule,
        UiModule,
        PeriodDurationPipe,
        FloatLabelModule,
        DmModule,
        PMessagesComponent
    ],providers: [AS_ENTITY_PROVIDER,AS_TEST_PROVIDERS]
})
export class AsModule implements DynamicModule {

    alias = 'as';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return AsKpiComponent;
    }

    getStatisticsComponent() {
        return AsStatisticsComponent;
    }
}
